/**
 * Accesos por usuario: qué módulos/menús del sistema puede ver, departamentos
 * y grupo (rotación de sábados) — al estilo del panel "Usuarios y accesos".
 */
/** Módulos/ítems del menú lateral del sistema de trazabilidad. */
export const MODULOS = [
    { clave: 'dashboard', nombre: 'Dashboard Préstamos' },
    { clave: 'buscar', nombre: 'Buscar Expediente' },
    { clave: 'crear', nombre: 'Crear Expediente', rol: 'creador' },
    { clave: 'misDocumentos', nombre: 'Mis Documentos' },
    { clave: 'cambioOficina', nombre: 'Cambio Oficina' },
    { clave: 'adjuntar', nombre: 'Adjuntar Documentos' },
    { clave: 'prestar', nombre: 'Prestar Carpetas' },
    { clave: 'reportes', nombre: 'Reportes y Turnos' },
    { clave: 'administracion', nombre: 'Usuarios y accesos', rol: 'admin' },
];
/**
 * `prestar` es un permiso, no solo un menú: sin él no se puede originar un
 * préstamo. Por defecto lo tiene la oficina de documentación (CENTRAL); el
 * admin puede concedérselo a quien haga turnos de préstamo.
 */
export const MODULO_PRESTAR = 'prestar';
/** `reportes` da acceso a los reportes de turno (líderes y coordinación). */
export const MODULO_REPORTES = 'reportes';
export const CLAVES_MODULO = MODULOS.map((m) => m.clave);
/**
 * Accesos por defecto de un usuario normal: buscar carpetas (ver estado y
 * abrirlas en Drive), adjuntar documentos y ver sus propios préstamos.
 * El resto (dashboard, préstamos, oficinas, reportes, administración) es
 * elevado: el admin lo habilita explícitamente a quien corresponda.
 */
export const ACCESOS_DEFECTO = ['buscar', 'adjuntar', 'misDocumentos'];
/** Departamentos (igual que el portal). */
export const DEPARTAMENTOS = [
    'Cartera', 'Recuperación', 'Calidad', 'Coordinación Operativa', 'Jurídico',
    'Comercial', 'Desarrollo', 'Talento Humano', 'Contabilidad', 'Seminarios',
    'Auditoría', 'SG-SST',
];
/** Grupo de rotación de sábados. */
export const GRUPOS = ['Grupo A', 'Grupo B', 'Grupo C'];
/** ¿El usuario tiene acceso a un módulo (por acceso explícito o por rol)? */
export function tieneAcceso(accesos, roles, clave) {
    if (roles.includes('admin'))
        return true;
    const mod = MODULOS.find((m) => m.clave === clave);
    if (mod && 'rol' in mod && mod.rol && !roles.includes(mod.rol))
        return false;
    return accesos.includes(clave);
}
//# sourceMappingURL=accesos.js.map